
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("32xcy", function(module, exports) {
/* ContentTreeSearch.tsx generated by @compiled/babel-plugin v0.40.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4nIKB = parcelRequire("4nIKB");


var $4yg9g = parcelRequire("4yg9g");


var $hAgam = parcelRequire("hAgam");


var $9DHhW = parcelRequire("9DHhW");


var $5avUB = parcelRequire("5avUB");


var $9GVkD = parcelRequire("9GVkD");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $lpNn5 = parcelRequire("lpNn5");


var $1B9Aq = parcelRequire("1B9Aq");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $ep3mz = parcelRequire("ep3mz");


var $56QzY = parcelRequire("56QzY");


var $6p02T = parcelRequire("6p02T");


var $b3j2Y = parcelRequire("b3j2Y");


var $ddhUv = parcelRequire("ddhUv");


var $6MlZq = parcelRequire("6MlZq");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $2vuKf = parcelRequire("2vuKf");


var $bwL2u = parcelRequire("bwL2u");


var $5oz05 = parcelRequire("5oz05");


var $882Qs = parcelRequire("882Qs");


var $amtnj = parcelRequire("amtnj");

const $c78306c195e02053$var$i18n = (0, $kSwu1.defineMessages)({
    searchLabel: {
        id: "space-views.content-tree-search.placeholder",
        defaultMessage: "Search by title"
    },
    clearSearch: {
        id: "space-views.content-tree-search.clear-search",
        defaultMessage: "Clear search"
    },
    searchInputDescription: {
        id: "space-views.content-tree-search.input-description",
        defaultMessage: "Results will update as you type."
    },
    searchResultsCount: {
        id: "space-views.content-tree-search.results-count",
        defaultMessage: "{count} {count, plural, one {result} other {results}} found"
    },
    disabledSearchTooltip: {
        id: "space-views.content-tree-search.disabled-label",
        defaultMessage: "Search is disabled when editing multiple items"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c78306c195e02053$var$TextfieldWrapperDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pku2gc _otyru2gc _18u0r5cr _1f4s12b0 _1thze4h9 _n6341l7x",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c78306c195e02053$var$ClearSearchButton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19itglyw _bfhk1j28 _2hwxt94y _4t3i1ou6 _1bsb1ou6 _u5f3rdoj _1e0c1txw _4cvr1h6o _1bah1h6o _80omtlke",
            __cmplp.className
        ])
    });
}); // same styles as a tooltip but with narrower width
const $c78306c195e02053$var$tooltipStyles = null; // same styles as a tooltip but with narrower width
const $c78306c195e02053$var$tooltipStylesUpdated = null;
const $c78306c195e02053$var$ToolTipOverride = /*#__PURE__*/ (0, $cozmU.forwardRef)(function ToolTipOverride({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            "_11q71aqn _2rkofajl _11c8wadc _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12f13lo",
            (0, $9wGTI.fg)('confluence_frontend_tokenize_border') && "_11q71aqn _2rko12b0 _11c8wadc _ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt _syaz15cr _p12f13lo"
        ])
    }, children);
});
const $c78306c195e02053$var$overlayCSS = null;
const $c78306c195e02053$var$overlayLoading = null;
const $c78306c195e02053$var$DisabledOverlay = ({ loading: loading, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": "content-tree-search-overlay",
        className: (0, $hekY6.default)([
            "_1bsb1osq _4t3i1osq",
            loading && "_tzy4105o _lcxvglyw _80om13gf"
        ])
    }, children);

const $c78306c195e02053$var$SpaceViewsMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ceKkd",
    name: "SpaceViewsMenuLoader",
    loader: async ()=>(await (parcelRequire("5BpuR"))).SpaceViewsMenu
});
const $c78306c195e02053$export$1b6339bfe8fdc588 = ({ children: children, contentTreeSize: contentTreeSize, shouldRenderAfterIcon: shouldRenderAfterIcon, selection: selection, setSelection: setSelection, isLicensed: isLicensed, canManageContentOrSuperAdmin: canManageContentOrSuperAdmin, ...hoverPageCardProps })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const intl = (0, $kSwu1.useIntl)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const inputRef = (0, $cozmU.useRef)(null);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [searchText, setSearchText] = (0, $cozmU.useState)('');
    const debouncedSearchText = (0, $ddhUv.useDebounce)(searchText, 200);
    const { searchResult: searchResult, loading: loading, error: error } = (0, $5oz05.useContentTreeSearch)(debouncedSearchText, 'sideNavigation');
    const isCreationADropdown = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const { disableMultiSelect: disableMultiSelect, exitMultiSelect: exitMultiSelect } = (0, $bwL2u.useContentTreeSelectionActions)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const handleChange = (0, $cozmU.useCallback)((e)=>{
        const inputValue = e.currentTarget.value || '';
        if (inputValue.length > 0) disableMultiSelect();
        else exitMultiSelect();
        setSearchText(inputValue);
    }, [
        disableMultiSelect,
        exitMultiSelect
    ]);
    const handleOnClearSearch = (0, $cozmU.useCallback)(()=>{
        setSearchText('');
        exitMultiSelect();
    }, [
        exitMultiSelect
    ]);
    const onItemClick = (0, $cozmU.useCallback)((id, index)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'pageTree',
                source: 'pageTree',
                objectId: id,
                attributes: {
                    spaceView: 'contentTreeSearch',
                    navdexPointType: (0, $56QzY.TOUCH),
                    searchResultCount: searchResult?.length,
                    searchResultIndex: index,
                    contentTreeSize: contentTreeSize
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        searchResult,
        contentTreeSize
    ]);
    const handleTextfieldFocus = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'focused',
                actionSubject: 'contentTreeSearch',
                source: 'sideNavigation',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    contentTreeSize: contentTreeSize
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentTreeSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": "content-tree-search",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c78306c195e02053$var$TextfieldWrapperDiv, {
        id: "contentTreeSearch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        columnGap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isMultiSelectActive ? intl.formatMessage($c78306c195e02053$var$i18n.disabledSearchTooltip) : '',
        position: "bottom",
        component: $c78306c195e02053$var$ToolTipOverride
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ...tooltipProps,
            ref: (0, $4nIKB.mergeRefs)([
                tooltipProps.ref,
                inputRef
            ]),
            "aria-label": intl.formatMessage($c78306c195e02053$var$i18n.searchLabel),
            "aria-describedby": "contentTreeSearchInfo",
            placeholder: intl.formatMessage($c78306c195e02053$var$i18n.searchLabel),
            onChange: handleChange,
            onFocus: handleTextfieldFocus,
            value: searchText,
            elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                paddingInlineStart: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                label: "",
                color: "var(--ds-icon-accent-gray, #7D818A)"
            })),
            elemAfterInput: searchText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c78306c195e02053$var$ClearSearchButton, {
                onClick: handleOnClearSearch
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: intl.formatMessage($c78306c195e02053$var$i18n.clearSearch),
                color: "var(--ds-icon-subtle, #505258)"
            })) : null,
            isCompact: true,
            isDisabled: isMultiSelectActive
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: "contentTreeSearchInfo"
    }, intl.formatMessage($c78306c195e02053$var$i18n.searchInputDescription)), edition === 'PREMIUM' && isLicensed && canManageContentOrSuperAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c78306c195e02053$var$SpaceViewsMenuLoader, {
        selection: selection,
        setSelection: setSelection,
        isWhiteboardBetaEnabled: isCreationADropdown,
        edition: edition,
        canManageContentOrSuperAdmin: canManageContentOrSuperAdmin
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c78306c195e02053$var$DisabledOverlay, {
        loading: loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $882Qs.ContentTreeSearchErrorLoader), null)) : searchResult && searchResult.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $882Qs.ContentTreeSearchEmptyLoader), null) : null), !error ? !searchResult ? children : searchResult.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$c78306c195e02053$var$i18n.searchResultsCount,
        values: {
            count: searchResult.length
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $amtnj.SpaceViewsList), {
        pagesList: searchResult,
        spaceKey: spaceKey,
        contentId: contentId,
        onItemClick: onItemClick,
        renderTitle: ({ title: title })=>(0, $6p02T.enrichExcerpt)(title),
        shouldRenderAfterIcon: shouldRenderAfterIcon,
        ...hoverPageCardProps
    })) : null : null));
};
module.exports["ContentTreeSearch"] = $c78306c195e02053$export$1b6339bfe8fdc588;

});

parcelRegister("6p02T", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?/[\]_\-+=`~|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("ddhUv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $10706a64f92ac80e$export$21805fee57372823 = (key, time)=>{
    const [lastKey, setLastKey] = (0, $cozmU.useState)(key);
    (0, $cozmU.useEffect)(()=>{
        if (key !== lastKey) {
            const timeout = setTimeout(()=>{
                setLastKey(key);
            }, time);
            return ()=>clearTimeout(timeout);
        }
    }, [
        key,
        lastKey,
        time
    ]);
    return lastKey;
};
module.exports["useDebounce"] = $10706a64f92ac80e$export$21805fee57372823;

});

parcelRegister("6MlZq", function(module, exports) {
const $2b534f0161088f49$export$f5501c77c624c70 = ()=>{
    /**
	 * DO NOT MODIFY THIS METHOD.
	 * This method has been refactored to return true as part of an effort to remove LaunchDarkly feature flags.
	 * Returning true avoids regressions.
	 * This method will be removed when ALL dependent feature flags have been removed.
	 * This work is being tracked in https://hello.jira.atlassian.cloud/browse/CTIA-2808
	 */ return true;
};
module.exports["useIsCreationDropdownEnabled"] = $2b534f0161088f49$export$f5501c77c624c70;

});

parcelRegister("5BpuR", function(module, exports) {

let $41442f937334956a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41442f937334956a$var$load("lgIhe"),
    $41442f937334956a$var$load("fC3D2")
]).then(()=>parcelRequire('a0Cao'));

});


//# sourceMappingURL=ContentTreeSearch.a5133fc6.js.map
